import React from "react";
import {
  IconWrapper,
} from "./styles";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { indigo } from '@mui/material/colors';

const VisibilityIcons = ({ ...props }) => {
  return (
    <IconWrapper>
      {props.isVisible ? (
        <VisibilityIcon
          onClick={() =>
            props.setShowPassword({
              ...props.showPassword,
              [props.typePassword]: !props.isVisible,
            })
          }
          sx={{
            color: indigo[500],
          }}
        />
      ) : (
        <VisibilityOffIcon
          onClick={() =>
            props.setShowPassword({
              ...props.showPassword,
              [props.typePassword]: !props.isVisible,
            })
          }
          sx={{
            color: indigo[500],
          }}
        />
      )}
    </IconWrapper>
  );
};
export default VisibilityIcons;
